// APP ENTRY POINT
// BOOTSTRAP all other includes etc
import "core-js/stable"; //Modules declared on webpack.common.js
import "regenerator-runtime/runtime";
// import "core-js/modules/es.promise";
// import "core-js/modules/es.array.iterator";
import "Js/bootstrap";

// "core-js/stable",
//     "regenerator-runtime/runtime",
//     "core-js/modules/es.promise",
//     "core-js/modules/es.array.iterator",
console.time('LOAD_SITE_MODEL')

// CSS
require("bootstrap/dist/css/bootstrap.min.css");
require("./assets/css/main.css");
require("animate.css/animate.min.css");

import Vue from "vue";

// STORE
import store from "Js/store";
// ROUTER
import router from "Js/routes.js";
// FEATHERS
import "Js/feathers";
// BF function library
import "Js/BF";


// GLOBAL COMPONENTS
import VRuntimeTemplate from "v-runtime-template";
Vue.component("html-renderer", VRuntimeTemplate);
Vue.component ("app" , require("@/assets/components/masters/app.vue").default)

// VUE
var app = new Vue({
  store: store,
  el: "#app",
  router: router,
  
}).$mount("#app");

// Vue.config.errorHandler = function (err, vm, info) {
//     BF.errorThrow (10040, 'BF global errorHandler (See info for details)' , {err, info})
//     return false
// };
// Vue.config.warnHandler = function (err, vm, info) {
//     BF.errorThrow (10042, 'BF global warnHandler (See info for details)' , {err, info})
//     return false
// };

Vue.config.devtools = true; 
window.vueapp = app;
